import { useState, useContext, useEffect } from "react";
import context from "../../store/context";

import useInput from "../../hooks/use-Input";

import AuthenticationButton from "../Buttons/AuthenticationButton";
import FieldRow, { rowInputClass } from "../UI/FieldRow";

const CompanyInfo = () => {
  const { userInfo, setUserInfo } = useContext(context);

  const validateCompanyInfo = () => {
    return true;
  };

  const {
    enteredValue: companyNameValue,
    valueChangeHandler: companyNameValueChangeHandler,
    inputBlurHandler: companyNameInputBlurHandler,
    reset: companyNameReset,
  } = useInput(
    validateCompanyInfo,
    userInfo.companyName === null ? "" : userInfo.companyName
  );

  const {
    enteredValue: tinValue,
    valueChangeHandler: tinChangeHandler,
    inputBlurHandler: tinInputBlurHandler,
    reset: tinReset,
  } = useInput(validateCompanyInfo, userInfo.tin === null ? "" : userInfo.tin);

  const {
    enteredValue: addressValue,
    valueChangeHandler: addressChangeHandler,
    inputBlurHandler: addressInputBlurHandler,
    reset: addressReset,
  } = useInput(
    validateCompanyInfo,
    userInfo.address === null ? "" : userInfo.address
  );

  useEffect(() => {
    companyNameReset();
    tinReset();
    addressReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  const userToken = sessionStorage.getItem("token");
  const [isUpdating, setIsUpdating] = useState(false);

  const updatePersonalInfo = () => {
    setIsUpdating(true);
    var headers = new Headers();
    headers.append("X-XSRF-TOKEN", "csrf-cookie");
    headers.append("Accept", "application/json");
    headers.append("Authorization", `Bearer ${userToken}`);

    var requestOptions = {
      method: "POST",
      headers: headers,
      redirect: "follow",
    };

    fetch(
      `https://api.ichereta.com/api/client/account/company?company_name=${companyNameValue}&tin=${tinValue}&address=${addressValue}`,
      requestOptions
    )
      .then((response) => {
        if (response.status === 401) {
          sessionStorage.clear();
          window.location.href = "/";
        }
        return response.json();
      })
      .then((result) => {
        setIsUpdating(false);

        setUserInfo({
          ...userInfo,
          name: result.user.name,
          email: result.user.email,
          phone: result.user.client_info.phone,
          address: result.user.client_info.address,
          companyName: result.user.client_info.company_name,
          tin: result.user.client_info.TIN,
        });
      })
      .catch((error) => {
        setIsUpdating(false);
        console.log("error", error);
      });
  };
  return (
    <div className="flex flex-col gap-5">
      <div className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-[0_2px_10px_rgba(61,89,132,0.06)]">
        <FieldRow label="Company Name">
          <input
            id="companyInfoName"
            type="text"
            placeholder="Company name"
            value={companyNameValue}
            onChange={companyNameValueChangeHandler}
            onBlur={companyNameInputBlurHandler}
            className={rowInputClass}
          />
        </FieldRow>
        <FieldRow label="TIN">
          <input
            id="companyInfoTIN"
            type="number"
            placeholder="TIN number"
            value={tinValue}
            onChange={tinChangeHandler}
            onBlur={tinInputBlurHandler}
            className={rowInputClass}
          />
        </FieldRow>
        <FieldRow label="Address" last>
          <input
            id="companyInfoAddress"
            type="text"
            placeholder="Address"
            value={addressValue}
            onChange={addressChangeHandler}
            onBlur={addressInputBlurHandler}
            className={rowInputClass}
          />
        </FieldRow>
      </div>
      <AuthenticationButton
        process={isUpdating}
        onClick={updatePersonalInfo}
        className="w-full h-12 bg-[#664bc7] hover:bg-[#664bc7]/90 text-white rounded-xl font-semibold transition-colors relative overflow-hidden"
        name="Save Changes"
      />
    </div>
  );
};

export default CompanyInfo;
